import { render, staticRenderFns } from "./recurring-orders.vue?vue&type=template&id=72025f73&scoped=true&"
import script from "./recurring-orders.vue?vue&type=script&lang=ts&"
export * from "./recurring-orders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72025f73",
  null
  
)

export default component.exports